import type { EnemyTemplate } from './types';

export const ENEMIGOS: Record<string, EnemyTemplate> = {
  cazador_humano: {
    id: 'cazador_humano',
    nombre: 'Cazador Furtivo',
    descripcionCorta: 'Humano flaco con trampas y un rifle antiguo.',
    paleta: 'humano',
    vida: 35,
    armadura: 12,
    modAtaque: 3,
    danoMin: 4,
    danoMax: 9,
    xpRecompensa: 40,
    loot: [{ itemId: 'cartucho_gastado', cantidad: 1 }],
    ai: {
      umbralDefensivo: 0.25,
      agresividadOportunista: 0.6,
      especial: {
        id: 'disparo_certero',
        nombre: 'Disparo Certero',
        descripcionCorta: 'Apunta y dispara. Mucho daño si conecta.',
        danoMin: 10,
        danoMax: 16,
        costoInterno: 3,
      },
    },
  },
  capibara_sombra: {
    id: 'capibara_sombra',
    nombre: 'Capibara de la Sombra',
    descripcionCorta: 'Uno de los disidentes. Rápido, mordedura precisa.',
    paleta: 'sombra',
    vida: 22,
    armadura: 14,
    modAtaque: 4,
    danoMin: 3,
    danoMax: 7,
    xpRecompensa: 30,
    ai: {
      umbralDefensivo: 0.2,
      agresividadOportunista: 0.75,
      especial: {
        id: 'tajo_doble',
        nombre: 'Tajo Doble',
        descripcionCorta: 'Dos mordiscos rápidos, uno tras otro.',
        danoMin: 6,
        danoMax: 10,
        costoInterno: 2,
      },
    },
  },
  oso_del_fuego: {
    id: 'oso_del_fuego',
    nombre: 'Oso del Fuego',
    descripcionCorta: 'Grande, lento, con pelaje chamuscado de tanto pasar por las Tierras Quemadas.',
    paleta: 'fuego',
    vida: 60,
    armadura: 11,
    modAtaque: 4,
    danoMin: 8,
    danoMax: 14,
    xpRecompensa: 80,
    ai: {
      umbralDefensivo: 0.3,
      agresividadOportunista: 0.5,
      especial: {
        id: 'embate_demoledor',
        nombre: 'Embate Demoledor',
        descripcionCorta: 'Ignora defensa. Devastador.',
        danoMin: 14,
        danoMax: 22,
        costoInterno: 4,
      },
    },
  },
};

export function obtenerEnemigo(id: string): EnemyTemplate | undefined {
  return ENEMIGOS[id];
}
